/**
 * @generated SignedSource<<ec9f40b51a333a4d3bbeb99902fee0c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AvatarIcon_actor$data = {
  readonly user: {
    readonly lastActiveAt: any | null;
    readonly " $fragmentSpreads": FragmentRefs<"useUserThumbnailUrl_user">;
  } | null;
  readonly " $fragmentType": "AvatarIcon_actor";
};
export type AvatarIcon_actor$key = {
  readonly " $data"?: AvatarIcon_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"AvatarIcon_actor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvatarIcon_actor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNode",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastActiveAt",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useUserThumbnailUrl_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ActorInterface",
  "abstractKey": "__isActorInterface"
};

(node as any).hash = "72b6b0528698ea8c8a76eb30ef54f219";

export default node;
